import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Tooltip } from '@mui/material';
import { differenceInHours } from 'date-fns';
import AlertIcon from './alert-icon';
import { getMomentFormattedDate } from '#helper';

const alertStatuses = {
  currentAlert: 1,
  pastAlert: 2,
  confirmedAlerts: 3,
  noAlert: 5
};

export const getIconProps = (excursions, account) => {
  const { currentAlert, pastAlert, confirmedAlerts, noAlert } = alertStatuses;

  if (!excursions) {
    return {
      iconType: null,
      message: ''
    };
  }

  if (excursions.length > 0) {
    const unconfirmed = excursions.filter(e => !e.acceptance);
    if (unconfirmed.length) {
      const date = new Date();
      const unconfirmed24h = unconfirmed.filter(e =>
        differenceInHours(date, new Date(e.messageTimestamp)) <= 24);

      if (unconfirmed24h.length) {
        return {
          iconType: currentAlert,
          message: `Alert was triggered: ${getMomentFormattedDate(unconfirmed24h[0].messageTimestamp, account)}`
        };
      }

      return {
        iconType: pastAlert,
        message: `Alert was triggered: ${getMomentFormattedDate(unconfirmed[0].messageTimestamp, account)}`
      };
    }
    return {
      iconType: confirmedAlerts,
      message: 'All alerts accepted'
    };
  }

  return {
    iconType: noAlert,
    message: 'No alerts'
  };
};

const AlertStatus = props => {
  const { logs, isMobile } = props;
  const account = useSelector(s => s.account, shallowEqual);

  const { iconType, message } = getIconProps(logs, account);

  if (!message && !iconType) {
    return null;
  }

  const tooltip = message;

  return (
    !isMobile ? (
      <Tooltip title={tooltip}>
        <div>
          <AlertIcon
            iconType={iconType}
            alertStatuses={alertStatuses}
          />
        </div>
      </Tooltip>
    ) : (
      <AlertIcon
        iconType={iconType}
        alertStatuses={alertStatuses}
      />
    )
  );
};

export default AlertStatus;
